import { render, staticRenderFns } from "./FactFamilyPlan.vue?vue&type=template&id=65da4db8&"
import script from "./FactFamilyPlan.vue?vue&type=script&lang=js&"
export * from "./FactFamilyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports